"use client";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useEffect, useRef, useState, } from "react";
import { deleteCookie } from "cookies-next";
import { useRouter } from "next/navigation";
import { TravelError } from "@travel/shared/utils";
import { useLoading } from "@travel/shared/hooks";
import { useAnalytics } from "@travel/shared/data-access";
import { mutateAmplifyUser } from "@travel/shared/auth/utils";
import { getAmplifyAuth, onUserChanged } from "../amplify";
export var INITIAL_AUTH_STATE = {
    user: null,
    isReady: false,
    isSignUpConfirmed: false,
    isConfirmingSignUp: false,
    confirmSignUpError: null,
    isCreatingUser: false,
    createUserError: null,
    isLoggingIn: false,
    loginError: null,
    isVerifyEmailSent: false,
    isSendingVerifyEmail: false,
    sendVerifyEmailError: null,
    isResettingPassword: false,
    isPasswordReset: false,
    resetPasswordError: null,
    isConfirmingNewPassword: false,
    isNewPasswordConfirmed: false,
    confirmNewPasswordError: null,
    isChangingPassword: false,
    isPasswordChanged: false,
    changePasswordError: null,
};
export var AuthContext = createContext([
    INITIAL_AUTH_STATE,
    {
        create: function () { return Promise.resolve(null); },
        confirmSignUp: function () { return Promise.resolve(false); },
        login: function () { return Promise.resolve(null); },
        logout: function () { return Promise.resolve(); },
        resetPassword: function () { return Promise.resolve(false); },
        confirmNewPassword: function () { return Promise.resolve(false); },
        sendEmailVerification: function () { return Promise.resolve(false); },
        changePassword: function () { return Promise.resolve(false); },
    },
]);
export function AuthProvider(_a) {
    var _this = this;
    var children = _a.children, _b = _a.defaultUser, defaultUser = _b === void 0 ? null : _b, onCreateUser = _a.onCreateUser, onUserChange = _a.onUserChange;
    var router = useRouter();
    var track = useAnalytics().track;
    var initRef = useRef(true);
    var _c = __read(useState(false), 2), isReady = _c[0], setIsReady = _c[1];
    var _d = __read(useState(defaultUser), 2), user = _d[0], setUser = _d[1];
    var _e = __read(useLoading(function (_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.email, email = _c === void 0 ? "" : _c, _d = _b.redirect, redirect = _d === void 0 ? "" : _d;
        return __awaiter(_this, void 0, void 0, function () {
            var auth;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0: return [4 /*yield*/, getAmplifyAuth()];
                    case 1:
                        auth = _e.sent();
                        return [4 /*yield*/, auth.resendSignUp(email)];
                    case 2:
                        _e.sent();
                        return [2 /*return*/, true];
                }
            });
        });
    }), 2), sendEmailVerification = _e[0], _f = _e[1], isSendingVerifyEmail = _f.isLoading, isVerifyEmailSent = _f.data, sendVerifyEmailError = _f.error;
    var _g = __read(useLoading(function (_a) {
        var email = _a.email, password = _a.password, firstName = _a.firstName, lastName = _a.lastName, redirect = _a.redirect;
        return __awaiter(_this, void 0, void 0, function () {
            var Auth, result, createdWithEmail, isEmailVerifyRequired, user_1, error_1;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        track("auth:signUp", {
                            email: email,
                            firstName: firstName,
                            lastName: lastName,
                        });
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, getAmplifyAuth()];
                    case 2:
                        Auth = _c.sent();
                        return [4 /*yield*/, Auth.signUp({
                                username: email,
                                password: password,
                                attributes: {
                                    email: email,
                                    name: "".concat(firstName, " ").concat(lastName),
                                },
                                autoSignIn: {
                                    enabled: true,
                                },
                            })];
                    case 3:
                        result = _c.sent();
                        createdWithEmail = ((_b = result.codeDeliveryDetails) === null || _b === void 0 ? void 0 : _b.AttributeName) === "email";
                        isEmailVerifyRequired = !result.userConfirmed && createdWithEmail;
                        user_1 = mutateAmplifyUser(result.user, {
                            email: createdWithEmail ? result.user.getUsername() : "",
                            isEmailVerifyRequired: isEmailVerifyRequired,
                            isEmailVerified: isEmailVerifyRequired && result.userConfirmed,
                        });
                        track("auth:signUp:success", {
                            email: email,
                            firstName: firstName,
                            lastName: lastName,
                        });
                        //await onCreateUser?.(user);
                        return [2 /*return*/, user_1];
                    case 4:
                        error_1 = _c.sent();
                        track("auth:signUp:error", {
                            email: email,
                            firstName: firstName,
                            lastName: lastName,
                            error: error_1,
                        });
                        throw new TravelError({
                            code: error_1 === null || error_1 === void 0 ? void 0 : error_1.code,
                            message: error_1 === null || error_1 === void 0 ? void 0 : error_1.message,
                            stack: error_1 === null || error_1 === void 0 ? void 0 : error_1.stack,
                            input: {
                                email: email,
                                firstName: firstName,
                                lastName: lastName,
                            },
                        });
                    case 5: return [2 /*return*/];
                }
            });
        });
    }, [sendEmailVerification]), 2), create = _g[0], _h = _g[1], isCreatingUser = _h.isLoading, createUserError = _h.error;
    var _j = __read(useLoading(function (_a) {
        var email = _a.email, code = _a.code;
        return __awaiter(_this, void 0, void 0, function () {
            var auth, result, error_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, getAmplifyAuth()];
                    case 1:
                        auth = _b.sent();
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 4, , 5]);
                        track("auth:signUp:confirm", {
                            email: email,
                        });
                        return [4 /*yield*/, auth.confirmSignUp(email, code)];
                    case 3:
                        result = _b.sent();
                        track("auth:signUp:confirm:success", {
                            email: email,
                        });
                        return [2 /*return*/, true];
                    case 4:
                        error_2 = _b.sent();
                        track("auth:signUp:confirm:error", {
                            email: email,
                            error: error_2,
                        });
                        throw error_2;
                    case 5: return [2 /*return*/];
                }
            });
        });
    }, []), 2), confirmSignUp = _j[0], _k = _j[1], isConfirmingSignUp = _k.isLoading, isSignUpConfirmed = _k.data, confirmSignUpError = _k.error;
    var _l = __read(useLoading(function (input) { return __awaiter(_this, void 0, void 0, function () {
        var _a, _b, providerName, _c, email, _d, password, auth, cognitoUser, user_2, error_3;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _a = typeof input === "object" ? input : { provider: input }, _b = _a.provider, providerName = _b === void 0 ? "" : _b, _c = _a.email, email = _c === void 0 ? "" : _c, _d = _a.password, password = _d === void 0 ? "" : _d;
                    return [4 /*yield*/, getAmplifyAuth()];
                case 1:
                    auth = _e.sent();
                    cognitoUser = null;
                    track("auth:login", {
                        provider: providerName,
                        email: email,
                    });
                    console.log("LOGIN");
                    _e.label = 2;
                case 2:
                    _e.trys.push([2, 5, , 6]);
                    if (!(providerName === "Email")) return [3 /*break*/, 4];
                    return [4 /*yield*/, auth.signIn(email, password)];
                case 3:
                    cognitoUser = _e.sent();
                    return [3 /*break*/, 4];
                case 4:
                    user_2 = mutateAmplifyUser(cognitoUser);
                    track("auth:login:success", {
                        provider: providerName,
                        userId: user_2.id,
                        email: email,
                        metric: {
                            data: {
                                attributes: {
                                    name: "Sign In",
                                },
                                type: "metric",
                            },
                        },
                        properties: {
                            action: "Sign In",
                        },
                    });
                    return [2 /*return*/, user_2];
                case 5:
                    error_3 = _e.sent();
                    track("auth:login:error", {
                        provider: providerName,
                        email: email,
                    });
                    throw error_3;
                case 6: return [2 /*return*/];
            }
        });
    }); }, []), 2), login = _l[0], _m = _l[1], isLoggingIn = _m.isLoading, loginError = _m.error;
    var logout = useCallback(function (reload) {
        if (reload === void 0) { reload = true; }
        return __awaiter(_this, void 0, void 0, function () {
            var auth, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!user)
                            return [2 /*return*/];
                        return [4 /*yield*/, getAmplifyAuth()];
                    case 1:
                        auth = _a.sent();
                        track("auth:signOut", {
                            userId: user.id,
                            email: user.email,
                        });
                        deleteCookie("search"); //@TODO: Handle more elegantly & globally
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, auth.signOut()];
                    case 3:
                        _a.sent();
                        track("auth:signOut:success", {
                            userId: user.id,
                            email: user.email,
                        });
                        return [3 /*break*/, 5];
                    case 4:
                        error_4 = _a.sent();
                        track("auth:signOut:error", {
                            userId: user.id,
                            email: user.email,
                            error: error_4,
                        });
                        return [3 /*break*/, 5];
                    case 5:
                        if (reload) {
                            window.location.reload();
                        }
                        return [2 /*return*/];
                }
            });
        });
    }, [user]);
    var _o = __read(useLoading(function (email) { return __awaiter(_this, void 0, void 0, function () {
        var auth;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getAmplifyAuth()];
                case 1:
                    auth = _a.sent();
                    track("auth:resetPassword", {
                        email: email,
                    });
                    return [4 /*yield*/, auth.forgotPassword(email)];
                case 2:
                    _a.sent();
                    return [2 /*return*/, true];
            }
        });
    }); }, []), 2), resetPassword = _o[0], _p = _o[1], isResettingPassword = _p.isLoading, isPasswordReset = _p.data, resetPasswordError = _p.error;
    var _q = __read(useLoading(function (_a) {
        var email = _a.email, code = _a.code, password = _a.password;
        return __awaiter(_this, void 0, void 0, function () {
            var auth;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, getAmplifyAuth()];
                    case 1:
                        auth = _b.sent();
                        return [4 /*yield*/, auth.forgotPasswordSubmit(email, code, password)];
                    case 2:
                        _b.sent();
                        return [2 /*return*/, true];
                }
            });
        });
    }, []), 2), confirmNewPassword = _q[0], _r = _q[1], isConfirmingNewPassword = _r.isLoading, isNewPasswordConfirmed = _r.data, confirmNewPasswordError = _r.error;
    var _s = __read(useLoading(function (_a) {
        var current = _a.current, password = _a.password;
        return __awaiter(_this, void 0, void 0, function () {
            var auth, currentUser, error_5;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, getAmplifyAuth()];
                    case 1:
                        auth = _b.sent();
                        return [4 /*yield*/, auth.currentAuthenticatedUser()];
                    case 2:
                        currentUser = _b.sent();
                        _b.label = 3;
                    case 3:
                        _b.trys.push([3, 5, , 6]);
                        track("auth:changePassword", {
                            userId: currentUser.id,
                            email: currentUser.email,
                        });
                        return [4 /*yield*/, auth.changePassword(currentUser, current, password)];
                    case 4:
                        _b.sent();
                        track("auth:changePassword:success", {
                            userId: currentUser.id,
                            email: currentUser.email,
                        });
                        return [2 /*return*/, true];
                    case 5:
                        error_5 = _b.sent();
                        track("auth:changePassword:error", {
                            userId: currentUser.id,
                            email: currentUser.email,
                        });
                        throw error_5;
                    case 6: return [2 /*return*/];
                }
            });
        });
    }, []), 2), changePassword = _s[0], _t = _s[1], isChangingPassword = _t.isLoading, isPasswordChanged = _t.data, changePasswordError = _t.error;
    useEffect(function () {
        var listener = onUserChanged(handleUserChanged);
        getAmplifyAuth()
            .then(function (auth) { return auth.currentAuthenticatedUser(); })
            .then(handleUserChanged)
            .catch(function (error) { return handleUserChanged(null, "unauthenticated", error); });
        return function () {
            listener.then(function (unsubscribe) { return unsubscribe(); });
        };
    }, []);
    return (_jsx(AuthContext.Provider, { value: [
            {
                user: user,
                isReady: isReady,
                isSignUpConfirmed: !!isSignUpConfirmed,
                isConfirmingSignUp: isConfirmingSignUp,
                confirmSignUpError: confirmSignUpError,
                isCreatingUser: isCreatingUser,
                createUserError: createUserError,
                isLoggingIn: isLoggingIn,
                loginError: loginError,
                isSendingVerifyEmail: isSendingVerifyEmail,
                isVerifyEmailSent: !!isVerifyEmailSent,
                sendVerifyEmailError: sendVerifyEmailError,
                isResettingPassword: isResettingPassword,
                isPasswordReset: !!isPasswordReset,
                resetPasswordError: resetPasswordError,
                isConfirmingNewPassword: isConfirmingNewPassword,
                isNewPasswordConfirmed: !!isNewPasswordConfirmed,
                confirmNewPasswordError: confirmNewPasswordError,
                isChangingPassword: isChangingPassword,
                isPasswordChanged: !!isPasswordChanged,
                changePasswordError: changePasswordError,
            },
            {
                create: create,
                confirmSignUp: confirmSignUp,
                login: login,
                logout: logout,
                resetPassword: resetPassword,
                confirmNewPassword: confirmNewPassword,
                sendEmailVerification: sendEmailVerification,
                changePassword: changePassword,
            },
        ], children: children }));
    function loginUser(user) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!((_a = user === null || user === void 0 ? void 0 : user.tokens) === null || _a === void 0 ? void 0 : _a.id)) return [3 /*break*/, 2];
                        return [4 /*yield*/, fetch("/api/login", {
                                method: "GET",
                                headers: {
                                    Authorization: "Bearer ".concat(user.tokens.id),
                                },
                            })];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    }
    function handleUserChanged(cognitoUser, event, error) {
        return __awaiter(this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                initRef.current = false;
                user = cognitoUser ? mutateAmplifyUser(cognitoUser) : null;
                setIsReady(true);
                setUser(user);
                onUserChange === null || onUserChange === void 0 ? void 0 : onUserChange(user, event);
                if (user) {
                    switch (event) {
                        case "signIn":
                        case "cognitoHostedUI":
                            track("auth:signIn", {
                                userId: user.id,
                                email: user.email,
                            });
                            break;
                        case "signOut":
                            track("auth:signOut", {
                                userId: user.id,
                                email: user.email,
                            });
                            break;
                    }
                }
                return [2 /*return*/];
            });
        });
    }
}
